import axios from "axios";

const baseURL = "https://pdfs-merger.onrender.com";
// const baseURL = "http://localhost:3001";

const instance = axios.create({
  baseURL: baseURL,
  headers: { "content-type": "application/json" },
});

export default instance;
